export const REGISTER_NEW_ADMIN = 'register_new_admin';
export const LOGIN_ADMIN = 'login_admin';
export const GET_FLOOR_DATA = 'get_floor_data';